export const MasterDataClassificationType = {
  ITEM: 'ITEM',
  COMPANY: 'COMPANY',
  RESOURCEONE: 'RESOURCEONE',
  EMPLOYEE: 'EMPLOYEE',
};

export const MasterDataClassificationTypeList = (submenuNames) => [
  { label: 'Cikkek', value: MasterDataClassificationType.ITEM },
  { label: 'Üzleti partnerek', value: MasterDataClassificationType.COMPANY },
  { label: submenuNames[0], value: MasterDataClassificationType.RESOURCEONE },
  { label: 'Dolgozók', value: MasterDataClassificationType.EMPLOYEE },
];

export const MasterDataClassificationField = {
  CLASS1: 'class1',
  CLASS2: 'class2',
  CLASS3: 'class3',
  CLASS4: 'class4',
  CLASS5: 'class5',
  CLASS6: 'class6',
  CLASS7: 'class7',
  CLASS8: 'class8',
  CLASS9: 'class9',
  CLASS10: 'class10',
  CLASS11: 'class11',
  CLASS12: 'class12',
  CLASS13: 'class13',
  CLASS14: 'class14',
  CLASS15: 'class15',
  CLASS16: 'class16',
  CLASS17: 'class17',
  CLASS18: 'class18',
  CLASS19: 'class19',
  CLASS20: 'class20',
};

export const MasterDataClassificationFieldList = [
  { label: 'Besorolás 1', value: MasterDataClassificationField.CLASS1 },
  { label: 'Besorolás 2', value: MasterDataClassificationField.CLASS2 },
  { label: 'Besorolás 3', value: MasterDataClassificationField.CLASS3 },
  { label: 'Besorolás 4', value: MasterDataClassificationField.CLASS4 },
  { label: 'Besorolás 5', value: MasterDataClassificationField.CLASS5 },
  { label: 'Besorolás 6', value: MasterDataClassificationField.CLASS6 },
  { label: 'Besorolás 7', value: MasterDataClassificationField.CLASS7 },
  { label: 'Besorolás 8', value: MasterDataClassificationField.CLASS8 },
  { label: 'Besorolás 9', value: MasterDataClassificationField.CLASS9 },
  { label: 'Besorolás 10', value: MasterDataClassificationField.CLASS10 },
  { label: 'Besorolás 11', value: MasterDataClassificationField.CLASS11 },
  { label: 'Besorolás 12', value: MasterDataClassificationField.CLASS12 },
  { label: 'Besorolás 13', value: MasterDataClassificationField.CLASS13 },
  { label: 'Besorolás 14', value: MasterDataClassificationField.CLASS14 },
  { label: 'Besorolás 15', value: MasterDataClassificationField.CLASS15 },
  { label: 'Besorolás 16', value: MasterDataClassificationField.CLASS16 },
  { label: 'Besorolás 17', value: MasterDataClassificationField.CLASS17 },
  { label: 'Besorolás 18', value: MasterDataClassificationField.CLASS18 },
  { label: 'Besorolás 19', value: MasterDataClassificationField.CLASS19 },
  { label: 'Besorolás 20', value: MasterDataClassificationField.CLASS20 },
];
